import { Box, Typography } from '@mui/material';

import {
  FBoxContainer,
  FCheckbox,
  FHConfirmDialog,
  FHInputField,
} from '../../../../components/base';
import { Roles } from '../../../../constants';
import { areUserRolesIn } from '../../../../helpers';
import { FORTA_ERROR } from '../../../../utils/colors';
import { PROVIDER_SSN_REVEAL_PASSWORD_MIN_LENGTH } from '../constants';
import { useProviderDetailsState, useProviderReviewerBcba } from '../hooks';
import { PROVIDER_SSN_NO_HELPER_INPUT_SX } from '../styles';

import type { ChangeEvent } from 'react';

export function ProviderReviewerBcba() {
  const { provider, user } = useProviderDetailsState();
  const {
    dialogOpen,
    password,
    setPassword,
    submitting,
    error,
    pendingActive,
    openDialog,
    closeDialog,
    submit,
  } = useProviderReviewerBcba(provider?.id);

  const renderPasswordContent = () => (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, my: 3 }}>
      <FHInputField
        autoComplete="off"
        aria-label="Password"
        inputProps={{ minLength: PROVIDER_SSN_REVEAL_PASSWORD_MIN_LENGTH }}
        placeholder="Password"
        sx={PROVIDER_SSN_NO_HELPER_INPUT_SX}
        type="password"
        value={password}
        onChange={(event: ChangeEvent<HTMLInputElement>) => setPassword(event.target.value)}
      />
      {error ? <Typography color={FORTA_ERROR}>{error}</Typography> : null}
    </Box>
  );

  return (
    <FBoxContainer>
      <Typography variant="h6" mb={2}>
        Reviewer BCBA
      </Typography>
      <FCheckbox
        label="Reviewer BCBA"
        checked={provider?.is_reviewer_bcba ?? false}
        disabled={
          !areUserRolesIn(user?.roles, [Roles.Admin]) ||
          (!provider?.roles?.includes(Roles.Bcba) && !provider?.is_reviewer_bcba) ||
          submitting
        }
        onChange={(event: ChangeEvent<HTMLInputElement>) => openDialog(event.target.checked)}
      />
      <FHConfirmDialog
        open={dialogOpen}
        title={
          pendingActive
            ? 'Enter password to enable reviewer'
            : 'Enter password to disable reviewer'
        }
        submittext={pendingActive ? 'Enable reviewer' : 'Disable reviewer'}
        canceltext="Cancel"
        hideCloseIcon
        submitLoading={submitting}
        disableSubmitButton={
          !password || password.length < PROVIDER_SSN_REVEAL_PASSWORD_MIN_LENGTH
        }
        dialogHeight="auto"
        contentRenderer={renderPasswordContent}
        onClose={closeDialog}
        onSubmit={submit}
      />
    </FBoxContainer>
  );
}
